import { getDefaultI18n } from './chunk-2UGAFJLN.js';
import { toast } from 'sonner';
import { toErrorResponse } from '@authe/fe-commons/errors';
import { messageForError } from '@authe/fe-commons/i18n';
import { createLogger } from '@authe/fe-commons/logging';

var log = createLogger("ui-core:notify");
function bodyOf(error) {
  return "error" in error ? error.error : error;
}
function notifyError(error, opts = {}) {
  const response = toErrorResponse(error);
  const body = response.error;
  const resolved = messageForError(body, opts.i18n ?? getDefaultI18n() ?? void 0);
  log.warn("notifyError", {
    code: body.error_code ?? void 0,
    status: response.statusCode,
    correlationId: body.correlation_id ?? void 0
  });
  const resolvedDetail = [
    resolved.description === opts.title ? void 0 : resolved.description,
    resolved.userAction
  ].filter(Boolean).join(" ");
  const detail = opts.description ?? (resolvedDetail === "" ? void 0 : resolvedDetail);
  toast.error(opts.title ?? resolved.description, {
    id: opts.id,
    description: detail,
    duration: opts.durationMs,
    action: opts.action ? { label: opts.action.label, onClick: opts.action.onClick } : void 0
  });
  return response;
}
function notifySuccess(message, opts = {}) {
  toast.success(opts.title ?? message, {
    id: opts.id,
    description: opts.description,
    duration: opts.durationMs,
    action: opts.action ? { label: opts.action.label, onClick: opts.action.onClick } : void 0
  });
}
function notifyInfo(message, description) {
  toast(message, { description });
}
function notifyWarning(message, description) {
  toast.warning(message, { description });
}
function dismissNotification(id) {
  toast.dismiss(id);
}
function notify({ type, message, description, id, durationMs, action }) {
  const options = {
    id,
    description,
    duration: durationMs,
    action: action ? { label: action.label, onClick: action.onClick } : void 0
  };
  if (type === "success") toast.success(message, options);
  else if (type === "error") toast.error(message, options);
  else if (type === "warning") toast.warning(message, options);
  else toast(message, options);
}
function notifyPromise(promise, messages, opts = {}) {
  toast.promise(promise, {
    loading: messages.loading,
    success: messages.success,
    error: (err) => opts.title ?? messages.error ?? messageForError(bodyOf(toErrorResponse(err)), opts.i18n ?? getDefaultI18n() ?? void 0).description
  });
  return promise;
}

export { dismissNotification, notify, notifyError, notifyInfo, notifyPromise, notifySuccess, notifyWarning };
//# sourceMappingURL=chunk-ZGTIOM3T.js.map
//# sourceMappingURL=chunk-ZGTIOM3T.js.map